/** @file The editor's shared REST client instance (browser fetch, same-origin cookies). */
import { createApiClient } from './createApiClient';

/** Used by screens and shell flows; tests pass their own fake clients instead. */
export const api = createApiClient((url, init) => fetch(url, init));
